// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22.1218 13.4647L23.536 14.8789L21.4147 17.0002L23.536 19.1215L22.1218 20.5358L20.0005 18.4144L17.8791 20.5358L16.4649 19.1215L18.5862 17.0002L16.4649 14.8789L17.8791 13.4647L20.0005 15.586L22.1218 13.4647Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M3 3H21L14 12.8174V21H10V12.8174L3 3Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-filter-clear-filled')
export default class FilterClearFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'filter-clear-filled',
    }
  }
}
